export default class Video {
  constructor(element) {
    this.element = element;
    this.init();
  }

  init() {
    const observer = new IntersectionObserver(
      (entries, observer) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            this.playVideo();
            observer.unobserve(this.element);
          }
        });
      },
      { threshold: 0.5 }
    );
    observer.observe(this.element);

    window.addEventListener('scroll', () => this.updateScale());

    window.addEventListener('load', () => {
      setTimeout(() => {
        this.updateScale();
      }, 50);
    });

    requestAnimationFrame(() => this.updateScale());
  }

  playVideo() {
    if (this.element.tagName.toLowerCase() === 'video') {
      this.element.play().catch((err) => {
        console.warn('Impossible de lancer la vidéo automatiquement', err);
      });
    }
  }

  updateScale() {
    if (!this.element) return;

    const rect = this.element.getBoundingClientRect();
    const windowHeight = window.innerHeight || document.documentElement.clientHeight;

    const videoCenter = rect.top + rect.height / 2;
    const viewportCenter = windowHeight / 2;
    const distance = Math.abs(videoCenter - viewportCenter);

    const maxDistance = windowHeight / 2 + rect.height / 2;

    let ratio = 1 - distance / maxDistance;
    ratio = Math.max(0, Math.min(1, ratio));
    
    ratio = Math.pow(ratio, 1.3);

    let minScale = 0.9;
    let maxScale = 1.2;
    let scale = minScale + (maxScale - minScale) * ratio;
    
    let borderRadius = 21 / (ratio || 0.1);
    let maxBorderRadius = 50;
    
    if (borderRadius > maxBorderRadius) {
      borderRadius = maxBorderRadius;
    }

    this.element.style.borderRadius = `${borderRadius}px`;
    this.element.style.transform = `scale(${scale})`;
  }
}